import "./PagingControl.scss";

import {
  Button,
  ChevronEndIcon,
  ChevronStartIcon,
  Flex,
  Label,
  Text,
} from "@fluentui/react-northstar";
import React from "react";

type Props = {
  count: number;
  current: number;
  onChange: (value: number) => void;
};

export const PagingControl: React.FC<Props> = ({ count, current, onChange }) => {
  if (count <= 1) {
    return null;
  }

  return (
    <Flex vAlign="center" gap="gap.smaller">
      <div>
        <Button
          content={<Text content="Previous" size="small" />}
          className="paging-control__button paging-control__button-prev"
          disabled={current <= 0}
          icon={<ChevronStartIcon size="smaller" />}
          iconPosition="before"
          onClick={() => onChange(Math.max(0, current - 1))}
          size="small"
        />
      </div>
      <Flex.Item grow align="center">
        <Label
          fluid
          className="paging-control__info-container"
          content={
            <Text
              className="paging-control__info"
              align="center"
              content={`${current + 1}/${count}`}
              size="small"
            />
          }
        />
      </Flex.Item>
      <div>
        <Button
          content={<Text content="Next" size="small" />}
          icon={<ChevronEndIcon size="smaller" />}
          iconPosition="after"
          className="paging-control__button paging-control__button-next"
          disabled={current >= count - 1}
          onClick={() => onChange(Math.min(count - 1, current + 1))}
          size="small"
        />
      </div>
    </Flex>
  );
};
